import { render, staticRenderFns } from "./RenameContext.vue?vue&type=template&id=8f61e282&scoped=true"
import script from "./RenameContext.vue?vue&type=script&lang=js"
export * from "./RenameContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f61e282",
  null
  
)

export default component.exports